export default __webpack_public_path__ + "static/media/avatar-team-men.ee730ab1.jpg";